export const searchType = {
  activity: "観光",
  restaurant: "レストラン",
  hotel: "ホテル",
  flight: "フライト",
  dynamicPackage: "フライト+ホテル",
  optionalTour: "現地ツアー",
  cruise: "クルーズ",
};
